import { useNavigate } from 'react-router-dom';
import Img1 from '../../../assets/image/img_onkids_intro_1.jpg';
import Img2 from '../../../assets/image/img_onkids_intro_2.jpg';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import { useTranslation } from '../../../hook/useTranslation';

interface TitleProps {
  title: string;
}

function Title({ title }: TitleProps) {
  return (
    <div className="text-[20px] text-[1C1C1C] w-full text-left font-[700] mb-[20px]">{title}</div>
  );
}

interface TextProps {
  text: string;
}

function Text({ text }: TextProps) {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
}

export default function OnkidsAIIntro() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title={t('home.onkiz_ai.title')} onClickPrev={() => navigate(-1)} />
      <div className="pageInner bg-[#FFF]">
        <img src={Img1} alt="1" style={{ objectFit: 'contain' }} className="mb-[40px]" />
        <Title title={t('home.onkiz_ai.intro_title')} />
        <div className="w-full flex items-start justify-start gap-[8px]">
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
            {t('home.onkiz_ai.intro_desc')}
          </div>
        </div>
        <img
          src={Img2}
          alt="2"
          style={{ objectFit: 'contain' }}
          className="my-[40px]"
        />
        <Title title={t('home.onkiz_ai.lab_title')} />
        <Text text={t('home.onkiz_ai.lab_desc1')} />
        <div className="mb-[16px]" />
        <Text text={t('home.onkiz_ai.lab_desc2')} />
      </div>
    </FullHeightContainer>
  );
}
